import { pick } from 'ramda'

export const allowedProps = [
  'actions',
  'anyAction',
  'anyFeature',
  'features',
  'apps',
  'tiers',
  'negate',
  'Fallback',
  'PermissionFallback'
]

export const pickAllowedProps = pick(allowedProps)
